export default {
  namespaced: true,
  state: {
    from: undefined,
    to: undefined
  },
  mutations: {
    pushState(state, data, key = "from") {
      state[key] = {
        ...state[key],
        ...data
      };
    }
  },
  actions: {
    pushState({ commit }, data) {
      commit("pushState", data);
    }
  }
};
